module.exports = __webpack_public_path__ + "img/c7f0445.jpg";